import type { CreateCanopy, UpdateCanopy } from '@/types'
import type { Canopy } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'

export class CanopyService {
  static async findAll(query: BaseQuery) {
    try {
      const response = await axios.get<IPaginate<Canopy>>(`/canopies`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`CanopyService.findAll`', error)
    }
  }

  static async findOne(id: number) {
    try {
      const response = await axios.get<Canopy>(`/canopies/${id}`)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`CanopyService.findOne`', error)
    }
  }

  static async create(data: CreateCanopy) {
    try {
      const response = await axios.post<IResponse>(`/canopies`, data)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`CanopyService.create`', error)
    }
  }

  static async update(id: number, data: UpdateCanopy) {
    try {
      const response = await axios.patch<IResponse>(`/canopies/${id}`, data)
      return response.data
    } catch (error) {
      tryCatch('`CanopyService.update`', error)
    }
  }

  static async delete(id: number) {
    try {
      const response = await axios.delete<IResponse>(`/canopies/${id}`)
      return response.data
    } catch (error) {
      tryCatch('`CanopyService.delete`', error)
    }
  }
}
